import React from "react";

// Lightweight SVG charts — no external chart lib (keeps it fast & tiny)
export function LineChart({ data = [], color = "#0d9488", height = 60, max }) {
  if (!data.length) return <div className="h-[60px] flex items-center text-[12px] text-slate-400">No data</div>;
  const m = max || Math.max(...data) * 1.15 || 1;
  const w = 100;
  const step = data.length > 1 ? w / (data.length - 1) : w;
  const pts = data.map((v, i) => `${i * step},${height - (v / m) * height}`).join(" ");
  const area = `0,${height} ${pts} ${w},${height}`;
  return (
    <svg viewBox={`0 0 ${w} ${height}`} preserveAspectRatio="none" className="w-full" style={{ height }}>
      <polygon points={area} fill={color} opacity={0.12} />
      <polyline points={pts} fill="none" stroke={color} strokeWidth={2} vectorEffect="non-scaling-stroke" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}

export function BarChart({ data = [], labels = [], color = "#0d9488", height = 90 }) {
  const m = Math.max(...data, 1);
  return (
    <div className="flex items-end gap-1.5" style={{ height }}>
      {data.map((v, i) => (
        <div key={`bar-${i}-${v}`} className="flex-1 flex flex-col items-center justify-end h-full">
          <div className="w-full rounded-t" style={{ height: `${(v / m) * 100}%`, backgroundColor: color, minHeight: 3 }} />
          {labels[i] && <span className="text-[10px] text-slate-400 mt-1">{labels[i]}</span>}
        </div>
      ))}
    </div>
  );
}

export function Gauge({ value = 0, color = "#0d9488", size = 160 }) {
  const r = size / 2 - 12;
  const c = 2 * Math.PI * r;
  const off = c - (value / 100) * c;
  const center = size / 2;
  return (
    <svg width={size} height={size} className="-rotate-90">
      <circle cx={center} cy={center} r={r} fill="none" stroke="#eef2f1" strokeWidth={12} />
      <circle cx={center} cy={center} r={r} fill="none" stroke={color} strokeWidth={12} strokeLinecap="round" strokeDasharray={c} strokeDashoffset={off} style={{ transition: "stroke-dashoffset 0.8s ease" }} />
    </svg>
  );
}

export function Donut({ data = [], size = 160, thickness = 24 }) {
  const total = data.reduce((s, d) => s + d.value, 0) || 1;
  const r = (size - thickness) / 2;
  const c = 2 * Math.PI * r;
  let acc = 0;
  return (
    <svg width={size} height={size} className="-rotate-90">
      {data.map((d, i) => {
        const dash = (d.value / total) * c;
        const seg = (
          <circle key={`${d.color}-${i}`} cx={size / 2} cy={size / 2} r={r} fill="none" stroke={d.color} strokeWidth={thickness} strokeDasharray={`${dash} ${c - dash}`} strokeDashoffset={-acc} />
        );
        acc += dash;
        return seg;
      })}
    </svg>
  );
}
